import React from 'react';
import { CalendarDaysIcon, ClockIcon, DollarSignIcon } from 'lucide-react';
export function KeyHighlights() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2387">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2388">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2389">
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2390">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-2391">
              <CalendarDaysIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-2392" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-2393">
              2-Day Course
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2394">
              Both days taken consecutively. Must complete both days to pass the
              course.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2395">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-2396">
              <ClockIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-2397" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-2398">
              14+ Hours Total
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2399">
              Day 1: 9 hours · Day 2: 5+ hours of classroom and range
              instruction.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2400">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-2401">
              <DollarSignIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-2402" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-2403">
              From $140
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2404">
              Members: $140 · Non-Members: $220. Non-refundable except for
              cancelled classes.
            </p>
          </div>
        </div>
      </div>
    </div>;
}